<template>
  <pop-panel :name="'修改邮箱'">
    <component :is="currentPage" :form="form" @change="changeHandler"></component>
  </pop-panel>
</template>

<script>
  import PopPanel from "../../../shared/components/popPanel/index";
  import EmailOneStep from "./oneStep";
  import EmailTwoStep from "./twoStep";
  export default {
    name: "safeChangeEmail",
    components: {EmailTwoStep, EmailOneStep, PopPanel},
    data() {
      return {
        currentPage: EmailOneStep,
        components: {
          EmailOneStep,
          EmailTwoStep
        },
        form: {
          name: {
            value: '',
            validateStatus: '',
            help: '昵称需唯一'
          },
          code: {
            value: '',
            validateStatus: '',
            help: ''
          },
          newEmail: {
            value: '',
            validateStatus: '',
            help: ''
          },
          newCode: {
            value: '',
            validateStatus: '',
            help: ''
          },
        },
      }
    },
    methods: {
      changeHandler (stepName) {
        this.currentPage = this.components[stepName]
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
